import { api } from '../middleware/api';

// Define endpoints using injectApi pattern
export const pomproductApi = api
  .enhanceEndpoints({ addTagTypes: ['POMProduct'] })
  .injectEndpoints({
    endpoints: builder => ({
      getPOMProducts: builder.query<(po_mproduct & po_mgroup)[], any>({
        query: ({ cid, olid }) => `pomproduct/${cid}/${olid}`,
        providesTags: ['POMProduct']
      }),
      getPOMProductsInactive: builder.query<(po_mproduct & po_mgroup)[], any>({
        query: ({ cid, olid }) => `pomproduct/inactive/${cid}/${olid}`,
        providesTags: ['POMProduct']
      }),
      getPOMProductById: builder.query<po_mproduct, string>({
        query: id => `pomproduct/byid/${id}`,
        providesTags: ['POMProduct']
      }),
      importPOMProduct: builder.mutation<{}, FormData>({
        query: (importData: FormData) => ({
          url: `pomproduct/import`,
          method: 'POST',
          body: importData
        }),
        invalidatesTags: ['POMProduct']
      }),
      importPOMProductRates: builder.mutation<{}, FormData>({
        query: (importData: FormData) => ({
          url: `pomproduct/importrates`,
          method: 'POST',
          body: importData
        }),
        invalidatesTags: ['POMProduct']
      }),
      insertPOMProduct: builder.mutation({
        query: pomproduct => ({
          url: `pomproduct/`,
          method: 'POST',
          body: pomproduct
        }),
        invalidatesTags: ['POMProduct']
      }),
      updatePOMProduct: builder.mutation({
        query: pomproduct => ({
          url: `pomproduct/`,
          method: 'PUT',
          body: pomproduct
        }),
        invalidatesTags: ['POMProduct']
      }),
      deletePOMProduct: builder.mutation({
        query: pomproduct => ({
          url: `pomproduct/${pomproduct.pr_id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['POMProduct']
      })
    }),
    overrideExisting: false
  });

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetPOMProductsQuery,
  useGetPOMProductsInactiveQuery,
  useGetPOMProductByIdQuery,
  useImportPOMProductMutation,
  useImportPOMProductRatesMutation,
  useInsertPOMProductMutation,
  useUpdatePOMProductMutation,
  useDeletePOMProductMutation
} = pomproductApi;

